<template>
	<div id="class" class="columns">
		<div class="column">
			<div class="card">
				<header class="card-header">
					<section class="card-header-title">Herexamnes</section>
				</header>
				<header class="card-header" style="background-color:#eeeeee;padding: 12px;">
					<nav class="level">
						<div class="level-left">
							<div class="level-item">
								<b-field>
									<a class="button is-primary" @click="new_schoolyear()">
										<b-icon icon="plus-circle-outline"></b-icon>
										<span>Leerling Registreren</span>
									</a>
								</b-field>
							</div>
							<div class="level-item">
								<b-field></b-field>
							</div>
						</div>
					</nav>
				</header>

				<div style="padding:5px;">
					<b-table
						:data="reexams"
						default-sort="tbl_school.name"
						:bordered="false"
						:narrowed="true"
						:striped="true"
						:loading="loading"
						:paginated="isPaginated"
						:per-page="perPage"
						:current-page.sync="currentPage"
						:pagination-simple="isPaginationSimple"
						:default-sort-direction="defaultSortDirection"
						style="font-size:13px;"
					>
						<template slot-scope="props">
							<b-table-column width="40">
								<a class="button is-small is-warning" @click="handleClick(props.row.id)">
									<b-icon icon="pencil"></b-icon>
									<!-- <span>
										<b>Aanpassen</b>
									</span>-->
								</a>
							</b-table-column>
							<b-table-column
								label="Leerlingnr"
								field="student_id"
							>{{ padwithZeros(props.row.tbl_student.i_schoolnumber) }}{{ padwithZeros(props.row.tbl_student.i_testgroup) }}{{ padwithZeros(props.row.tbl_student.i_student_number) }}</b-table-column>
							<b-table-column
								label="Leerling"
								field="student_id"
							>{{ props.row.tbl_student.firstname }} {{props.row.tbl_student.surname }}</b-table-column>
							<b-table-column
								label="Herexamen"
								field="tbl_re_exam.exam_name_ned"
							>{{ props.row.tbl_re_exam.exam_name_ned }}</b-table-column>
							<b-table-column
								label="Datum"
								field="tbl_re_exam.re_exam_date"
							>{{ props.row.tbl_re_exam.re_exam_date }}</b-table-column>
							<b-table-column
								label="Start"
								field="tbl_re_exam.re_exam_time_start_ned"
							>{{ props.row.tbl_re_exam.re_exam_time_start_ned }}</b-table-column>
							<b-table-column
								label="Einde"
								field="tbl_re_exam.re_exam_time_finish_ned"
							>{{ props.row.tbl_re_exam.re_exam_time_finish_ned }}</b-table-column>
							<b-table-column label="Afwezig" field="tbl_re_exam.absent" centered>
							
								<b-checkbox
									size="is-small"
									v-model="props.row.tbl_re_exam.absent "
								></b-checkbox>
							</b-table-column>
						</template>
						<template slot="empty">
							<section class="section">
								<div class="content has-text-grey has-text-centered">
									<p>
										<b-icon icon-pack="far" icon="exclamation-triangle" size="is-large"></b-icon>
									</p>
									<p>Nothing here.</p>
								</div>
							</section>
						</template>
					</b-table>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Axios from "axios";
//import Icon from "vue-awesome/components/Icon.vue";
import Cookies from "js-cookie";

import { API_ROOT } from "../config";

var instance = Axios.create({
	baseURL: API_ROOT,
	timeout: 60000
});

export default {
	name: "class",
	created: function() {
		//this.getUnits()
		if (_.isUndefined(this.access == 0)) {
			this.$router.push({
				path: "/"
			});
		}

		this.getCurrentschoolyear();
		this.getReexams();
		this.getSchools();
	},

	data: function() {
		return {
			reexams: [],
			selected_objections: [],
			selected_school: 0,
			studentData: [],
			schools: [],
			currentschoolyear: 0,
			loading: false,
			access: Cookies.get("access"),
			user: Cookies.getJSON("user"),
			isEmpty: false,
			isPaginated: true,
			isPaginationSimple: false,
			defaultSortDirection: "asc",
			currentPage: 1,
			perPage: 12
		};
	},
	watch: {},
	methods: {
		getCurrentschoolyear() {
			var self = this;

			instance.get("/current-schoolyear").then(function(response) {
				console.log(response.data.data);

				self.currentschoolyear = response.data.data;
				self.getObjections();
			});
		},
		objection_save(id, value) {
			console.log(id);

			var self = this;
			this.$nextTick(function() {
				// DOM is now updated
				// `this` is bound to the current instance

				console.log(value);
				instance
					.post("/further-education-objection", {
						student_id: id,
						objection_result_id:
							value.tbl_student.tbl_further_education.objection_result_id
					})
					.then(function(response) {
						console.log(response.data.data);
					});
			});
		},
		padwithZeros(string) {
			return _.padStart(string, 2, "0");
		},
		getReexams: function() {
			var self = this;

			this.loading = true;
			instance.get("/studentreexam").then(function(response) {
				console.log("Get schools...");
				console.log(response.data.data);

				self.reexams = response.data.data;

				self.loading = false;
			});
		},
		getSchools: function() {
			var self = this;

			instance.get("/school").then(function(response) {
				console.log("Get schools...");
				console.log(response.data.data);
				console.log(self.Schools);

				var schools = _.remove(response.data.data, function(n) {
					return n.schoolnumber > 0;
				});
				schools = _.sortBy(schools, [
					function(o) {
						return o.schoolnumber;
					}
				]);
				self.schools = schools;
				//self.selected_school = Cookies.get("selected_school");
			});
		},
		handleClick(id) {
			this.$router.push({
				path: "/studentreexam/" + id
			});
		},
		getSelectedClass: function(id) {
			console.log(id);
			self = this;
			//todo:
			this.loading = true;

			instance.get("/student-class/objection/" + id).then(function(response) {
				console.log(response.data.data);

				self.studentData = response.data.data;

				self.loading = false;
			});
		}
	}
};
</script>
<style scoped>
</style>
